import { Box, Button, Typography } from "@mui/material";
import React from "react";
import Icon from "../MUI/Icon";
import TaskIcon from '@mui/icons-material/Task';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
const FileUploaded = ({ fileName, size, setFile, node }) => {
  return (
    <Box
      sx={{
        border: "1px solid #e6e6e6",
        borderRadius: 2,
        width: "100%",
        p: 2,
        boxShadow: "0 4px 10px rgba(0,0,0,0.04)",
        bgcolor: "#fff",
        ...node?.style,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, flex: 1 }}>
        
      {node?.icon?  <Icon sx={{ verticalAlign: "middle", bgcolor: "red" }}>
          <span
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            dangerouslySetInnerHTML={{ __html: node?.icon }}
          />
        </Icon>: <TaskIcon sx={{ color: "#005230", width: 36, height: 36, flexShrink: 0 }} />}
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
           {fileName || "File Name"}
          </Typography>
          <Typography variant="body2" color="text.secondary">
           {fileName ? `${fileName.split('.').pop().toUpperCase()} | ${Math.round(size / 1024)}KB` : "PDF | 23KB"}
          </Typography>
        </Box>
      </Box>

      <Button 
      onClick={() => setFile(null)}
        sx={{
          color: 'var(--SMA-sys-light-primary, #601350)',
          textAlign: 'center',
          fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '20px',
          letterSpacing: '0.1px',
          textTransform: 'none', 
          backgroundColor: 'transparent',
          borderRadius: "100px",
          border:"none"
         
        }}
      >
        Reupload
      </Button>
    </Box>
  );
};

export default FileUploaded;
